import React, { createRef } from 'react';
import { connect } from 'react-redux';
import axios from 'axios';
import withStyles from 'isomorphic-style-loader/withStyles';
import { injectIntl } from 'react-intl';

import { googleMapAPI, placeDetailURL, autoCompleteURL } from '../../../config';
import debounce from '../../../helpers/debounce';
import { googleMapLoader } from '../../../helpers/googleMapLoader';
import messages from '../../../locale/messages';

class PlaceGeoSuggest extends React.Component {

    static defaultProps = {
        label: '',
        className: '',
        defaultValue: '',
        containerClassName: ''
    };

    constructor(props) {
        super(props);
        this.state = {
            value: null,
            suggestion: [],
            googleMapsApiLoaded: false
        };
        this.dropdownRef = createRef();
    }

    async componentDidMount() {
        const { id, initialValue } = this.props;
        this.setState({ value: initialValue });
        await googleMapLoader();
        this.setState({ googleMapsApiLoaded: true });
        const isDocument = typeof document !== undefined;
        if (isDocument) {
            document.addEventListener('mousedown', this.handleClickOutside);
            document.addEventListener('touchstart', this.handleClickOutside);
        }
        window.addEventListener('click', function (e) {

        });
    }

    componentWillUnmount() {
        const isDocument = typeof document !== undefined;
        if (isDocument) {
            document.addEventListener('mousedown', this.handleClickOutside);
            document.addEventListener('touchstart', this.handleClickOutside);
        }
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        const { locale, intl, initialValue } = nextProps;
        const { locale: oldLocale } = this.props;
        const { value, errorMessageChange } = this.state;
        this.setState({ value: initialValue });
        if (oldLocale == locale && errorMessageChange) {
            this.handleGeoSuggestFailure({ target: { value } }, intl.formatMessage(messages.locationWarning));
        }
        this.setState({ errorMessageChange: oldLocale != locale });
    }

    handleClickOutside = (event) => {
        const { id } = this.props;
        if (this.dropdownRef?.current && !this.dropdownRef?.current?.contains(event?.target)) {
            this.setState({ suggestion: [] });
            const parentSection = document.getElementById('safariFailureGeoSuggestionDropDown' + id);
            const childSection = document.getElementById('suggestItem' + id);
            if (parentSection && childSection) {
                parentSection.removeChild(childSection);
            }
        }
    }


    handleGeoSuggestFailure = (e, message) => {
        const { id } = this.props;
        const { formatMessage } = this.props.intl;
        const { errorMessageChange } = this.state;
        const suggestionsContainer = document.getElementById('safariFailureGeoSuggestionDropDown' + id);
        if (suggestionsContainer) {
            suggestionsContainer.style.display = "block";
            let suggestionItem = document.createElement("div");
            suggestionItem.id = 'suggestItem' + id;
            suggestionItem.classList.add('geoSuggestItem')
            suggestionItem.textContent = formatMessage(messages.locationWarning);
            if (e.target.value != "") {
                if (!document.getElementById('suggestItem' + id)) {
                    suggestionsContainer.appendChild(suggestionItem);
                } else if (errorMessageChange && message) {
                    suggestionItem.textContent = message;
                    suggestionsContainer.replaceChild(suggestionItem, document.getElementById('suggestItem' + id));
                    this.setState({ errorMessageChange: false })
                }
            } else {
                const parentSection = document.getElementById('safariFailureGeoSuggestionDropDown' + id);
                const childSection = document.getElementById('suggestItem' + id);
                if (parentSection && childSection) {
                    parentSection.removeChild(childSection);
                }
            }
            this.setState({ value: e.target.value });
        }
    }

    handleAutoComplete = debounce(async (value) => {
        const { onChange } = this.props;
        onChange && onChange(value);
        if (value?.length > 0) {
            const requestData = { input: value };
            axios.post(
                autoCompleteURL,
                requestData,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Goog-Api-Key': googleMapAPI
                    }
                }
            ).then(response => {
                if (response?.data?.suggestions?.length > 0) {
                    this.setState({
                        suggestion: response?.data?.suggestions
                    });
                }
            }).catch(error => {
                console.error('Error:', error?.response ? error?.response?.data : error?.message);
            });

        }
    }, 100)


    handleSuggest = async ({ placeId, value }) => {
        const { handleSelectSuggest } = this.props;

        if (placeId) {
            try {
                const response = await axios.get(`${placeDetailURL}${placeId}`, {
                    headers: {
                        'Content-Type': 'application/json',
                        'X-Goog-Api-Key': googleMapAPI,
                        'X-Goog-FieldMask': '*'
                    }
                });
                if (response?.data) {
                    const updatedData = { ...response.data, value };
                    handleSelectSuggest(updatedData, value);
                    this.setState({ value, suggestion: [] });
                }
            } catch (error) {
                console.error('Place Details Error:', error?.response?.data || error?.message);
            }
        }
    }

    render() {
        const { label, id, className, containerClass, disabled } = this.props;
        const { value, suggestion, googleMapsApiLoaded } = this.state;

        return (
            <div className={containerClass} ref={this.dropdownRef}>
                {
                    googleMapsApiLoaded ? <>
                        <div className='loadingInputContainer'>
                            <input
                                id={id}
                                type='text'
                                placeholder={label}
                                value={value}
                                disabled={disabled}
                                autoComplete='off'
                                className={className}
                                onChange={(e) => {
                                    this.setState({ value: e?.target?.value });
                                    if (e?.target?.value?.length > 0) {
                                        this.handleAutoComplete(e?.target?.value);
                                    } else {
                                        this.setState({ suggestion: [] });
                                    }
                                }}
                            />
                            {
                                suggestion?.length > 0 && (
                                    <ul className='manualGeoSuggestWrapper'>
                                        {
                                            suggestion?.map((item, itemIndex) => {
                                                return (
                                                    <li key={itemIndex} className='geoSuggestItem'
                                                        onClick={() => this.handleSuggest({ placeId: item?.placePrediction?.placeId, value: item?.placePrediction?.text?.text })}
                                                    >
                                                        {item?.placePrediction?.text?.text}
                                                    </li>
                                                )
                                            })}
                                    </ul>
                                )
                            }
                        </div>
                    </> :
                        <div className='loadingInputContainer safariFailureGeoSuggest'>
                            <input
                                type='text'
                                value={value}
                                className={className}
                                placeholder={label}
                                autoComplete='off'
                                onChange={(e) => this.handleGeoSuggestFailure(e)}
                            />
                            <div id={'safariFailureGeoSuggestionDropDown' + id} className='manualGeoSuggestWrapper' />
                        </div>
                }
            </div>
        );
    }
}

export default injectIntl(PlaceGeoSuggest);